import { OiguseKohustuseArtikkel } from '@/models/OiguseKohustuseArtikkel';
import { AxiosTeenus } from './axios-teenus';

export class OigusedJaKohustusedTeenus {

    public async minuOigusedJaKohustused(): Promise<OiguseKohustuseArtikkel[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<OiguseKohustuseArtikkel[]>(`/api/oigusedjakohustused/oigusedjakohustusedinfo`);

        return response?.data;
    }
}